/* eslint-disable react-hooks/exhaustive-deps */
import { Progress, Form, BackTop } from 'antd';
import classNames from 'classnames';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DCDPOService from '../../../services/DCDPO.service';
import UserManagementService from '../../../services/UserManagement.service';
import { useBlocker } from '../../../util/usePrompt';

import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import Step5 from './components/Step5';
import StepList from './components/StepList';
import StepPreview from './components/StepPreview';
import GlobalService from '../../../services/Global.service';
import moment from 'moment';
import { POLICY_NAME } from '../POLICY';
import CookiePolicyService from '../../../services/CookiePolicy.service';
import UserService from '../../../services/UserService';
import MyCompanyService from '../../../services/MyCompany.service';
import { convertToISODateTime } from '../../../util/util';

const { Provider } = Form;

const CookieDetail = () => {
    const { t } = useTranslation(['translation', 'cookies-policy']);
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();
    const userId = UserService.getUi();

    const [state, updateState] = useState();

    const [currentSelectList, setCurrentSelectList] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loading_] = useState(false);
    const [loadingSaveDraft] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editMode] = useState(false);

    // form
    const [cookiePolicy] = Form.useForm();
    const [cookieIntroductionLawfulBasis] = Form.useForm();
    const [cookieAreUsed] = Form.useForm();
    const [cookiePreferences] = Form.useForm();
    const [cookiePolicyChange] = Form.useForm();

    const [previewData, setPreviewData] = useState();

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [dsType, setDsType] = useState([]);
    const [domainList, setDomainList] = useState([]);
    const [domainId, setDomainId] = useState();
    const [cookieList, setCookieList] = useState();

    // check validations

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '8') {
            setFixed(false);
        }
    }, [location]);

    // get domain list
    useEffect(() => {
        const getDomainList = async (companyId) => {
            let ObjectSearch = {};
            ObjectSearch = {
                companyId: companyId,
                p: 1,
                ps: 10000,
                s: 'domainName',
                sd: 'ASC',
            };
            try {
                const { data } = await MyCompanyService.getDomainList(
                    ObjectSearch
                );
                const item = data?.resultData;
                setDomainList(item?.result?.filter((e) => e !== null) || []);
            } catch (err) {
                console.log(err);
            }
        };
        const getUserDetail = async () => {
            try {
                const { data } = await UserManagementService.getUserDetail(
                    userId
                );
                const item = data?.resultData;
                if (item?.companyId) {
                    getDomainList(item?.companyId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getUserDetail(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    // Sequence

    const genaratePayload = (name, isPublish) => {
        let payload = {};
        let values = {
            cookiePolicy: {
                ...cookiePolicy.getFieldsValue(),
                domainName: domainName?.domainName || '-',
                cookiePolicyId: id === 'new' ? undefined : id,
            },
            cookieIntroductionLawfulBasis: {
                ...cookieIntroductionLawfulBasis.getFieldsValue(),
                cookieIntroductionLawfulBasisId:
                    previewData?.cookieIntroductionLawfulBasis
                        ?.cookieIntroductionLawfulBasisId,
            },
            cookieAreUsed: {
                ...cookieAreUsed.getFieldsValue(),
                cookieAreUsedId: previewData?.cookieAreUsed?.cookieAreUsedId,
            },
            cookiePreferences: {
                ...cookiePreferences.getFieldsValue(),
                cookiePreferencesId:
                    previewData?.cookiePreferences?.cookiePreferencesId,
            },
            cookiePolicyChange: {
                ...cookiePolicyChange.getFieldsValue(),
                cookiePolicyChangeId:
                    previewData?.cookiePolicyChange?.cookiePolicyChangeId,
            },
        };

        let cookiePolicyDataSubjectType = [];

        const dsTypeGroup = values.cookiePolicy.cookiePolicyDataSubjectType;

        if (dsTypeGroup) {
            const dsTypefilter = dsType.filter((ds) =>
                dsTypeGroup.includes(ds.id)
            );
            cookiePolicyDataSubjectType = dsTypefilter.map((ds) => {
                return {
                    cookieDataSubjectId: ds.id,
                    cookieDataSubjectNameTh: ds.nameTh,
                    cookieDataSubjectNameEn: ds.nameEn,
                };
            });
        }

        const effectiveDate = values.cookiePolicy?.effectiveDate
            ? moment(values.cookiePolicy?.effectiveDate).format(
                  'YYYY-MM-DDT00:00:00.000+00:00'
              )
            : null;

        payload = {
            cookiePolicy: {
                ...values.cookiePolicy,
                cookiePolicyDataSubjectType,
                effectiveDate,
                isPublish,
            },
            cookieIntroductionLawfulBasis: values.cookieIntroductionLawfulBasis,
            cookieAreUsed: values.cookieAreUsed,
            cookiePreferences: values.cookiePreferences,
            cookiePolicyChange: values.cookiePolicyChange,
        };
        return payload;
    };

    const saveDraft = async () => {
        const payload = genaratePayload(null, false);
        try {
            setChange(false);
            setOpenChange(false);
            const { data } = await CookiePolicyService.saveCookiePolicy(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                const cookiePolicyId = data?.resultData?.cookiePolicyId;
                const fullPath = window.location.href;
                const step = fullPath?.split('#')[1];
                getCookiePolicy(cookiePolicyId);
                navigate(
                    ROUTER?.POLICY?.COOKIE_PRIVACY +
                        `/${cookiePolicyId}#${step}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    const onFormFinish = async (name, _) => {
        const payload = genaratePayload(null, true);
        try {
            setChange(false);
            setOpenChange(false);
            const { data } = await CookiePolicyService.saveCookiePolicy(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                navigate(
                    `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.COOKIES_POLICY}`
                );
            } else {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('common.FailedSaveData'),
                });
            }
        } catch (error) {
            console.log(error);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('common.FailedSaveData'),
            });
        }
    };

    const getCookiePolicy = async (id) => {
        try {
            const { data } = await CookiePolicyService.getCookiePolicyDetail(
                id
            );
            if (data?.resultCode === 1) {
                const res = data?.resultData;
                const effDate = convertToISODateTime(
                    res?.cookiePolicy?.effectiveDate
                );
                const dsTypeId = [];
                res?.cookiePolicy?.cookiePolicyDataSubjectType?.forEach(
                    (val) => {
                        dsTypeId?.push(val?.cookieDataSubjectId);
                    }
                );
                setPreviewData({
                    cookiePolicy: {
                        ...res?.cookiePolicy,
                        cookieEffectiveDate: res?.cookiePolicy?.effectiveDate
                            ? moment(effDate)
                            : moment(),
                    },
                    cookieIntroductionLawfulBasis: {
                        ...res?.cookieIntroductionLawfulBasis,
                    },
                    cookieAreUsed: {
                        ...res?.cookieAreUsed,
                    },
                    cookiePreferences: {
                        ...res?.cookiePreferences,
                    },
                    cookiePolicyChange: {
                        ...res?.cookiePolicyChange,
                    },
                });
                setDomainId(res?.cookiePolicy?.domainId);
                cookiePolicy?.setFieldsValue({
                    ...res?.cookiePolicy,
                    cookiePolicyDataSubjectType: dsTypeId,
                    cookieEffectiveDate: res?.cookiePolicy?.effectiveDate
                        ? moment(effDate)
                        : null,
                });
                cookieIntroductionLawfulBasis?.setFieldsValue({
                    ...res?.cookieIntroductionLawfulBasis,
                });
                cookieAreUsed?.setFieldsValue({
                    ...res?.cookieAreUsed,
                });
                cookiePreferences?.setFieldsValue({
                    ...res?.cookiePreferences,
                });
                cookiePolicyChange?.setFieldsValue({
                    ...res?.cookiePolicyChange,
                });
            }
        } catch (error) {}
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDsType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getCookieDomain = async (domainId) => {
            const { data } = await CookiePolicyService.getCookieDomain(
                domainId
            );
            const res = data?.resultData;
            if (data?.resultCode === 1) {
                setCookieList(res);
            }
        };
        if (domainId) getCookieDomain(domainId);
    }, [domainId]);

    useEffect(() => {
        getDsTypeDropdown();
        setLoading(true);
        if (id !== 'new') getCookiePolicy(id);
        else getDCDPO();
    }, [id]);

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                cookiePolicyChange.setFieldsValue({
                    cookieDataControllerContentTh: item?.staffNameDPOTh,
                    cookieDataControllerContentEn: item?.staffNameDPOEn,
                    cookieDataProtectionContentTh: `${item?.nameDPOTh}\n${item?.addressTh}`,
                    cookieDataProtectionContentEn: `${item?.nameDPOEn}\n${item?.addressEn}`,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const domainName = domainList.find(
        (domain) => cookiePolicy.getFieldValue('domainId') === domain.domainId
    );

    const steps = [step1, step2, step3, step4, step5];
    const stepPreview = steps.length + 1;
    const passStep = steps.every((step) => step === true);
    const filter = steps.filter(Boolean).length;
    const currentProgress = ((filter * 100) / steps.length).toFixed(0);
    const stepObject = steps.reduce((result, step, index) => {
        const stepName = `step${index + 1}`;
        return { ...result, [stepName]: step };
    }, {});

    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.COOKIES_POLICY}`
                        );
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Cookies Policy', {
                                  ns: POLICY_NAME.COOKIES_POLICY,
                              })
                            : t('Edit Cookies Policy', {
                                  ns: POLICY_NAME.COOKIES_POLICY,
                              })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} / {t('Cookies Policy')} /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add Cookies Policy', {
                              ns: POLICY_NAME.COOKIES_POLICY,
                          })
                        : t('Edit Cookies Policy', {
                              ns: POLICY_NAME.COOKIES_POLICY,
                          })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== stepPreview && (
                    <StepList
                        steps={stepObject}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== stepPreview,
                        'col-span-4': currentSelectList === stepPreview,
                    })}
                >
                    {currentSelectList !== 6 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    domainList={domainList}
                                    setStep1={setStep1}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cookiePolicy}
                                    previewData={previewData}
                                    dsType={dsType}
                                    setDomainId={setDomainId}
                                    saveDraft={saveDraft}
                                />
                                <Step2
                                    domainName={
                                        domainName
                                            ? domainName?.domainName
                                            : '[domain_name]'
                                    }
                                    setStep2={setStep2}
                                    previewData={previewData}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cookieIntroductionLawfulBasis}
                                    saveDraft={saveDraft}
                                />
                                <Step3
                                    cookiePolicy={cookiePolicy.getFieldsValue()}
                                    setStep3={setStep3}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cookieAreUsed}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                    cookieList={cookieList}
                                    domainId={domainId}
                                />
                                <Step4
                                    setStep4={setStep4}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cookiePreferences}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step5
                                    setStep5={setStep5}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cookiePolicyChange}
                                    previewData={previewData}
                                    passStep={passStep}
                                    saveDraft={saveDraft}
                                />
                                <StepPreview
                                    loading_={loading_}
                                    loadingSaveDraft={loadingSaveDraft}
                                    loading={loading}
                                    forms={{
                                        cookiePolicy,
                                        cookieIntroductionLawfulBasis,
                                        cookieAreUsed,
                                        cookiePreferences,
                                        cookiePolicyChange,
                                    }}
                                    privacyNoticeId={id}
                                    saveDraft={saveDraft}
                                    dsType={dsType}
                                    cookieList={cookieList}
                                    onFormFinish={onFormFinish}
                                    domainId={domainId}
                                    domainList={domainList}
                                    previewData={previewData}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </Fragment>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default CookieDetail;
